export const uniqueId = () => Math.random().toString(36).substr(2, 9);

export const limitDecimals = (value, decimals = 2) =>
  value.indexOf(".") >= 0
    ? value.substr(0, value.indexOf(".")) +
      value.substr(value.indexOf("."), decimals + 1)
    : value;

export const clamp = (num, min, max) => Math.min(Math.max(num, min), max);
